import * as snackbar from './snackbar/snackbar.reducer';
import * as auth from './auth/auth.reducer';
import * as loadingSpinner from './loading-spinner/loading-spinner.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface AppState {
  auth: auth.State;
  snackBar: snackbar.State;
  loadingSpinner: loadingSpinner.State;
}

export const selectAuthState = createFeatureSelector<auth.State>('auth');

export const selectSnackbarState = createFeatureSelector<AppState>('snackbar');

export const selectSpinnerEntity = createFeatureSelector<loadingSpinner.State>(
  'loadingSpinner'
);

export const isSpinnerShowing = createSelector(
  selectSpinnerEntity,
  loadingSpinner.isShowing
);

export const isUserAuthenticated = createSelector(
  selectAuthState,
  auth.isUserAuthenticated
);

export const isFirstUserAccess = createSelector(selectAuthState, auth.isFirstUserAccess);
